import { render, staticRenderFns } from "./SearchListPage.vue?vue&type=template&id=6c85f7ec&scoped=true"
import script from "./SearchListPage.vue?vue&type=script&lang=js"
export * from "./SearchListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c85f7ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c85f7ec')) {
      api.createRecord('6c85f7ec', component.options)
    } else {
      api.reload('6c85f7ec', component.options)
    }
    module.hot.accept("./SearchListPage.vue?vue&type=template&id=6c85f7ec&scoped=true", function () {
      api.rerender('6c85f7ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/components/SearchListPage.vue"
export default component.exports